export default "__VITE_ASSET__HMG0I8lP__"